import {ReauthenticationNotice} from '../components/ReauthenticationNotice';

export function ReauthenticationModal() {
  return <ReauthenticationNotice />;
}
